import { render } from "./NicknamePopup.vue?vue&type=template&id=2f9fa196&scoped=true"
import script from "./NicknamePopup.vue?vue&type=script&lang=js"
export * from "./NicknamePopup.vue?vue&type=script&lang=js"

import "./NicknamePopup.vue?vue&type=style&index=0&id=2f9fa196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9fa196"]])

export default __exports__